import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RestaurantTable.css';

interface Restaurant {
  id: string;
  name: string;
  googlePlaceId: string;
  owner: string;
  status: 'active' | 'pending' | 'inactive';
  city: string;
  menuItems: number;
  activeDeals: number;
  created: string;
  verified?: boolean;
}

interface RestaurantTableProps {
  restaurants: Restaurant[];
  selectedRestaurants: string[];
  onSelectRestaurant: (restaurantId: string) => void;
  onSelectAll: () => void;
}

const RestaurantTable: React.FC<RestaurantTableProps> = ({
  restaurants,
  selectedRestaurants,
  onSelectRestaurant,
  onSelectAll,
}) => {
  const navigate = useNavigate();
  const allSelected = selectedRestaurants.length === restaurants.length && restaurants.length > 0;

  const getStatusClass = (status: string) => {
    return status.toLowerCase();
  };

  const truncatePlaceId = (placeId: string) => {
    if (placeId.length > 15) {
      return placeId.substring(0, 12) + '...';
    }
    return placeId;
  };

  return (
    <div className="restaurant-table-container">
      <table className="restaurant-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onSelectAll}
                className="table-checkbox"
              />
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Google Place ID</th>
            <th>Owners</th>
            <th>Status</th>
            <th>City</th>
            <th>Menu Items</th>
            <th>Active Deals</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {restaurants.map((restaurant) => (
            <tr
              key={restaurant.id}
              className="restaurant-row-clickable"
              onClick={() => navigate(`/restaurants/${encodeURIComponent(restaurant.id)}`)}
            >
              <td>
                <input
                  type="checkbox"
                  checked={selectedRestaurants.includes(restaurant.id)}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => onSelectRestaurant(restaurant.id)}
                  className="table-checkbox"
                />
              </td>
              <td className="restaurant-id">{restaurant.id}</td>
              <td
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/restaurants/${encodeURIComponent(restaurant.id)}`);
                }}
              >
                <div className="restaurant-name-cell">
                  <span>{restaurant.name}</span>
                  {restaurant.verified && (
                    <span className="verified-badge">Verified</span>
                  )}
                </div>
              </td>
              <td className="restaurant-place-id">{truncatePlaceId(restaurant.googlePlaceId)}</td>
              <td className="restaurant-owner">{restaurant.owner}</td>
              <td>
                <span className={`restaurant-status status-${getStatusClass(restaurant.status)}`}>
                  {restaurant.status}
                </span>
              </td>
              <td className="restaurant-city">{restaurant.city}</td>
              <td className="restaurant-menu-items">{restaurant.menuItems}</td>
              <td className="restaurant-deals">{restaurant.activeDeals}</td>
              <td className="restaurant-created">{restaurant.created}</td>
              <td>
                <button className="restaurant-actions-btn">⋯</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RestaurantTable;

